import * as types from "./actions";
import { MOBILE_ORDERS_LIST, DEFAULT_TIMEZONE } from "../../../../utils/constants";
import { TIMEOUT } from "../../../../config/settings";

const defaultState = {
    credentials:{},
    partnerCodes: [],
    isAuthenticated: false,
    showLoader:false,
    expiry: Date.now(),
    mobilePage: MOBILE_ORDERS_LIST,
    timezone_id: DEFAULT_TIMEZONE
};

export default function reducer (state=defaultState, action) {
    switch (action.type) {
        case types.SET_USER_AUTH:
            return {...state, credentials: action.payload, isAuthenticated: action.isAuthenticated, expiry: Date.now() + TIMEOUT};
        case types.EXTEND_TIMEOUT:
            return {...state, expiry: Date.now() + TIMEOUT};
        case types.SET_PARTNER_CODE:
            return {...state, partnerCodes: action.payload};
        case types.LOADER:
            return {...state, showLoader: action.payload};
        case types.SET_MOBILE_PAGE:
            return {...state, mobilePage: action.payload};
        case types.SET_TIMEZONE_OFFSET:
            return {...state, timezone_id: action.payload};
        case types.UPDATE_USERNAME:
            return {...state, credentials: {...state.credentials, user_nm: action.payload}};
        default: return state;
    }
};